import { Resource } from '.';
export interface OrderAddress {
  city: string;
  company: string;
  country: string;
  country_iso2: string;
  customer_id: number;
  email: string;
  first_name: string;
  form_fields?: {
    // Array of custom fields
    name: string;
    value: string;
  }[];
  last_name: string;
  phone: string;
  state: string;
  street_1: string;
  street_2?: string;
  zip: string;
}

export interface ShippingAddress {
  id: string;
  order_id: string;
  first_name: string;
  last_name: string;
  company: string;
  street_1: string;
  street_2?: string;
  city: string;
  zip: string;
  country: string;
  country_iso2: string;
  state: string;
  email: string;
  phone?: string;
  items_total: number;
  items_shipped: number;
  shipping_method: string;
  base_cost: string;
  cost_ex_tax: string;
  cost_inc_tax: string;
  cost_tax: string;
  cost_tax_class_id: number;
  base_handling_cost: string;
  handling_cost_ex_tax: string;
  handling_cost_inc_tax: string;
  handling_cost_tax: string;
  handling_cost_tax_class_id: number;
  shipping_zone_id: number;
  shipping_zone_name: string;
  shipping_quotes: {
    url: string;
    resource: string;
  };
}

export interface Order {
  base_handling_cost: string;
  base_shipping_cost: string;
  base_wrapping_cost: string;
  billing_address: OrderAddress;
  cart_id: string;
  channel_id: number;
  coupon_discount: string;
  coupons: Resource;
  credit_card_type?: string;
  currency_code: string;
  currency_exchange_rate: string;
  currency_id: number;
  custom_status: string;
  customer_id: number;
  customer_locale: string;
  customer_message: string;
  date_created: string;
  date_modified: string;
  date_shipped: string;
  default_currency_code: string;
  default_currency_id: number;
  discount_amount: string;
  ebay_order_id: string;
  external_id?: string;
  external_merchant_id?: string;
  external_source?: string;
  geoip_country: string;
  geoip_country_iso2: string;
  gift_certificate_amount: string;
  handling_cost_ex_tax: string;
  handling_cost_inc_tax: string;
  handling_cost_tax: string;
  handling_cost_tax_class_id: number;
  id: number;
  ip_address: string;
  ip_address_v6: string;
  is_deleted: boolean;
  is_email_opt_in: boolean;
  items_shipped: number;
  items_total: number;
  order_is_digital: boolean;
  order_source: string;
  payment_method: string;
  payment_provider_id: number | null;
  payment_status: string;
  products: Resource;
  refunded_amount: string;
  shipping_address_count: number;
  shipping_addresses: Resource;
  shipping_cost_ex_tax: string;
  shipping_cost_inc_tax: string;
  shipping_cost_tax: string;
  shipping_cost_tax_class_id: number;
  staff_notes: string;
  status: string;
  status_id: number;
  store_credit_amount: string;
  store_default_currency_code: string;
  store_default_to_transactional_exchange_rate: string;
  subtotal_ex_tax: string;
  subtotal_inc_tax: string;
  subtotal_tax: string;
  tax_provider_id: string;
  total_ex_tax: string;
  total_inc_tax: string;
  total_tax: string;
  wrapping_cost_ex_tax: string;
  wrapping_cost_inc_tax: string;
  wrapping_cost_tax: string;
  wrapping_cost_tax_class_id: number;
}

export enum OrderStatuses {
  PartiallyRefunded = 'Partially Refunded',
  Refunded = 'Refunded',
}

export enum CartTotalCode {
  shipping = 'shipping',
  surcharge = 'surcharge',
  subtotal = 'subtotal',
  discount = 'discount',
  tax = 'tax',
  grand_total = 'grand_total',
}
